package one.healthium.uscreen.domain.models

import kotlinx.serialization.Serializable
import one.healthium.uscreen.serialization.PlatformTextSerializer

@Serializable(with = PlatformTextSerializer::class)
data class PlatformText(
    val android: String,
    val ios: String,
) {
    constructor(text: String) : this(text, text)
}
